import React, { Component } from 'react'
import { Play } from './icons'
import FsLightbox from 'fslightbox-react'

class AgentProfileAbout extends Component {

  state = {
    videoLightbox: false,
  }

  render() {

    let { title, content, image, team, insights, video } = this.props
    let { videoLightbox } = this.state
    video = video !== '' ? `https://www.youtube.com/watch?v=${video.split('.be/')[1]}&autoplay=1` : ''

    return (
      <section className='agent-about'>
        <div className='agent-about__inner'>
          <div className='agent-about__title'>
            <h3>{title}</h3>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
          <div className='agent-about__image' onClick={() => video ? this.setState({ videoLightbox: !videoLightbox }) : null}>
            <img src={image?.sourceUrl} alt={`Kollosche - ${team.title}`} />
            { video && <span className='play'><Play color={'#233356'} /></span> }
          </div>
          <div className='agent-insights'>
            <h4>Insights</h4>
            {insights?.length > 0 &&
              <div className="agent-insights__stats">
                {insights.map((el, i) => (
                  <div className='agent-insights__stat' key={i}>
                    <p className='value'>{el.value}</p>
                    <p className='label' dangerouslySetInnerHTML={{ __html: el.label }} />
                  </div>
                ))}
              </div>
            }
          </div>
        </div>
        { video &&
          <FsLightbox
            toggler={videoLightbox}
            sources={ [
              video
            ]}
          />
        }
      </section>
    )
  }
}

AgentProfileAbout.defaultProps = {
  title: '',
  content: '',
  image: null,
  team: null,
  insights: [],
  video: '',
}

export default AgentProfileAbout
